import React from 'react';
import mongodbAtlasLogo from '../assets/components/mongodb-atlas-logo.png';
import awsLogo from '../assets/components/aws-logo.png';

const Footer = () => {
  return (
    <footer className="bg-gray-700 text-white [&_p]:text-gray-100 shadow-sm items-center sm:max-w-full border-t-2 border-cyan-200 mt-2">
      <div className="text-center">
        <div className="flex flex-row sm:flex-row flex-wrap justify-center text-sm">
          <a href="/about-us" className="text-xs text-yellow-300 mx-2 hover:underline">About</a> |
          <a href="/contact-us" className="text-xs text-yellow-300 mx-2 hover:underline">Contact</a> |
          <a href="/privacy-policy" className="text-xs text-yellow-300 mx-2 hover:underline">Privacy Policy</a> |
          <a href="/terms-of-use" className="text-xs text-yellow-300 mx-2 hover:underline">Terms of Use</a> |
          <a href="/refund-cancellation-policy" className="text-xs text-yellow-300 mx-2 hover:underline">Refund & Cancellation Policy | </a>
          <a href="/investinthink5whys" className="text-xs text-yellow-300 mx-2 hover:underline">Invest in Think5Whys</a>
        </div>
        
        {/* <h2 className="text-sm font-semibold mb-2 mt-2">About Technology</h2>
        <div className="flex flex-wrap justify-around gap-6">
          
        </div> */}
      </div>
        
      <div className="text-center text-xs mb-2">
        © {new Date().getFullYear()} Think5Whys Global DeepTech Solutions Private Limited - An Innovative DeepTech Solutions for Enterprise, Recognised Under DPIIT Startup India 
      </div>
      <div className='text-center text-xs mb-2'>
        <p className='text-xs'>Address: B-1402, Riviera, Casa-Bella, Palava, Kalyan-Shil Road, Dombivali (East), Thane , Mumbai Metropolitan Region, Maharashtra, India, Postal Code: 421204</p>
      </div>
      <div className="text-center text-xs mb-2">
        <a href="https://www.think5whys.com" className="text-orange-600 hover:underline" target="_blank" rel="noopener noreferrer">www.think5whys.com</a> | 
        {/* <a href="https://www.processifyd.com" className="text-green-700 hover:underline" target="_blank" rel="noopener noreferrer"> www.processifyd.com</a> | */}
        {/* <a href="https://www.madsmania.com" className="text-white hover:underline" target="_blank" rel="noopener noreferrer"> www.madsmania.com</a> */}
      </div>
      <div className="text-center text-xs">
        All rights reserved | Email: 
        <a href="mailto:contact@think5whys.com" className="text-yellow-300 hover:underline">contact@think5whys.com</a>
      </div>
    </footer>
  );
};

export default Footer;
